import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiClient } from "../utils/apiClient";
import { AdminInfoResponse } from "@services/admin/types";
import {
  setAdminInfo,
  setAdminInfoLoading,
  setAdminInfoError,
  setEnvInfo,
  setEnvInfoLoading,
  setEnvInfoError,
  EnvInfo
} from "./systemData";

// Async thunk for fetching admin info
export const fetchAdminInfo = createAsyncThunk(
  "systemData/fetchAdminInfo",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setAdminInfoLoading(true));

      const adminResponse = await apiClient.get<AdminInfoResponse>("/admin/info");

      dispatch(setAdminInfo(adminResponse));
      return adminResponse;
    } catch (error: any) {
      const errorMessage = error?.message || "Failed to fetch admin info";
      dispatch(setAdminInfoError(errorMessage));
      return rejectWithValue(errorMessage);
    }
  }
);

// Async thunk for fetching environment info
export const fetchEnvInfo = createAsyncThunk(
  "systemData/fetchEnvInfo",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setEnvInfoLoading(true));

      const envResponse = await apiClient.get<EnvInfo>("/user/env-info");

      dispatch(setEnvInfo(envResponse));
      return envResponse;
    } catch (error: any) {
      const errorMessage = error?.message || "Failed to fetch environment info";
      dispatch(setEnvInfoError(errorMessage));
      return rejectWithValue(errorMessage);
    }
  }
);